import React from "react";
import { FaGlobe, FaMobileAlt, FaDesktop } from "react-icons/fa";
function MobileWallets() {
  const reasons = [
    {
      icon: <FaGlobe size={32} />,
      title: "Web Wallets",
      desc: "Accessible through a browser, no download required.",
    },
    {
      icon: <FaMobileAlt size={32} />,
      title: "Mobile Wallets",
      desc: "Smartphone apps designed for on-the-go usage.",
    },
    {
      icon: <FaDesktop size={32} />,
      title: "Desktop Wallets",
      desc: "Software installed on a personal computer, offering a balance of convenience and security.",
    },
  ];
  return (
    <>
      <div
        className="feature-style-one-area default-padding bg-gray blurry-shape-right-bottom"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/3.png)",
        }}
      >
        <div className="container">
          <div className="text-center mb-5">
            <h2
              className="fw-bold"
              style={{ color: "#0a1f44", fontSize: "clamp(24px, 3vw, 38px)" }}
            >
              Type of Crypocurency Wallets
            </h2>
            <p
              className="text-muted mx-auto"
              style={{ maxWidth: "700px", fontSize: "16px" }}
            >
              Cryptocurrency wallets are mainly of three types; web wallets,
              mobile wallets and desktop wallets.
            </p>
          </div>
          <div className="row g-4 justify-content-center">
            {reasons.map((item, idx) => (
              <div className="col-lg-4 col-md-6" key={idx}>
                <div className="ce-why-card">
                  <div className="ce-why-icon d-flex align-items-center justify-content-center">
                    {item.icon}
                  </div>
                  <div>
                    <h5
                      className="fw-bold mb-2"
                      style={{ color: "#0a1f44", fontSize: "17px" }}
                    >
                      {item.title}
                    </h5>
                    <p
                      className="mb-0 text-muted"
                      style={{ fontSize: "14px", lineHeight: "1.6" }}
                    >
                      {item.desc}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default MobileWallets;
